export default __webpack_public_path__ + "static/media/PPH.e6de9743.png";